<template>
    <div class="trainer__edit_form">
        <template v-if="routeName === 'ebs-trainer-add'">
            <div class="trainer__edit_form_box">
                <component-note
                    v-if="!users.length"
                    :danger="true">
                    {{$t('ebs.trainers.add.alert')}}
                </component-note>
            </div>
            <transition name="fade">
                <form-select
                    v-show="users.length"
                    :label="$t('ebs.trainers.edit.labels.learnerAccount')"
                    :items="users"
                    :placeholder="$t('ebs.trainers.edit.labels.typeToSearch')"
                    :name="$t('ebs.trainers.edit.name.user')"
                    :required="true"
                    :data-vv-as="$t('forms.dataVvAs.learnerAccount')"
                    :v-validate="'required'"
                    :value="trainerUser"
                    @input="trainerUpdateUser"
                > {{ $t('ebs.trainers.edit.text.chooseLearner') }}
                </form-select>
            </transition>
        </template>
        <template v-else>
            <form-text
                :label="$t('ebs.trainers.edit.labels.name')"
                :name="$t('ebs.trainers.edit.name.name')"
                :required="true"
                :data-vv-as="$t('forms.dataVvAs.name')"
                :v-validate="'required|max:45'"
                :disabled="true"
                v-model="trainerName"
            >
            </form-text>
            <form-email
                :label="$t('ebs.trainers.edit.labels.email')"
                :name="$t('ebs.trainers.edit.name.email')"
                :required="true"
                :data-vv-as="$t('forms.dataVvAs.email')"
                :v-validate="'required'"
                :disabled="true"
                v-model="trainerEmail"
            >
            </form-email>
        </template>
        <form-image
            :label="$t('ebs.trainers.edit.labels.images')"
            :name="$t('ebs.trainers.edit.name.images')"
            :value="trainerImage"
            @emit-select="trainerUploadImage"
            @emit-remove="trainerRemoveImage"
        />
        <component-title :size="'medium'">{{ $t('ebs.trainers.edit.text.standardWorkingHours') }}</component-title>
        <form-hours
            :hours="trainerWorkingHours"
            @emit-update="trainerUpdateHours"
            name="trainer-working-hours"/>
        <form-submit
            @reset="performReset"
            @submit="performSubmitValidate"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ComponentNote from '@/components/default/shared/ComponentNote'
import FormText from '@/components/default/forms/FormText'
import FormImage from '@/components/default/forms/FormImage'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FormEmail from '@/components/default/forms/FormEmail'
import FormHours from '@/components/default/forms/FormHours'
import FormSubmit from '@/components/default/forms/FormSubmit'
import PopNotify from '@/components/default/shared/PopNotify'
import FormSelect from '@/components/default/forms/FormSelect'
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'

export default {
  name: 'trainer-edit-form',
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  components: {
    ComponentNote,
    FormSelect,
    PopNotify,
    FormSubmit,
    FormHours,
    FormEmail,
    ComponentTitle,
    FormImage,
    FormText
  },
  computed: {
    users: function () {
      const objectData = this.$store.getters.getUsers
      let objectDataArr = []
      if (objectData.length) {
        objectDataArr = objectData.map(function (object) {
          return {
            label: `${object.l_fname} ${object.l_lname} [${object.l_uname}] (${object.l_mail})`,
            value: { lmsId: object.lms_user_id, name: `${object.l_fname} ${object.l_lname}`, email: object.l_mail }
          }
        })
      }
      return objectDataArr
    },
    trainerName: {
      get () {
        return this.$store.getters['getTrainerName']
      },
      set (value) {
        this.$store.dispatch('setTrainerName', value)
      }
    },
    trainerEmail: {
      get () {
        return this.$store.getters['getTrainerEmail']
      },
      set (value) {
        this.$store.dispatch('setTrainerEmail', value)
      }
    },
    trainerUser: {
      get () {
        return this.$store.getters['getTrainerUser']
      }
    },
    trainerImage: {
      get () {
        return this.$store.getters['getTrainerImage']
      }
    },
    trainerWorkingHours: {
      get () {
        return this.$store.getters['getTrainerWorkingHours']
      }
    },
    routeName: function () {
      return this.$route.name
    },
    //
    watchContent () {
      return this.trainerName + this.trainerEmail + this.trainerUser + this.trainerImage
    },
    //
    rootItemName () {
      return 'trainer'
    },
    nameActionCreate () {
      return 'createTrainer'
    },
    nameActionUpdate () {
      return 'updateTrainer'
    },
    nameActionReset () {
      return 'resetTrainer'
    }
  },
  created () {
    this.getUsers()
  },
  methods: {
    getUsers: function () {
      if (this.$store.getters.getAuthUserIsSecondStageTokenOldLMS) {
        this.$store.dispatch('getUsers')
      }
    },
    //
    trainerUploadImage: function (data) {
      this.$store.dispatch('setTrainerImage', data)
    },
    trainerRemoveImage: function (key) {
      this.$store.dispatch('removeTrainerImage', key)
    },
    trainerUpdateUser: function (data) {
      this.$store.dispatch('setTrainerUser', data)
    },
    trainerUpdateHours: function (value) {
      this.$store.dispatch('setTrainerWorkingHours', value)
    }
  }
}
</script>
